<!-- xyk.vue -->
<template>
	<div class="xyk-container">
		<!-- 筛选条件区域 -->
		<div class="filter-section">
			<el-form :inline="true" :model="filterForm" class="filter-form">
				<el-form-item label="药品名称：">
					<el-input v-model="filterForm.drugName" placeholder="请输入药品名称" size="small" clearable
						style="width: 200px;" prefix-icon="el-icon-Ssearch" />
				</el-form-item>

				<el-form-item label="药品剂型：">
					<el-select v-model="filterForm.dosForm" placeholder="请选择药品剂型" size="small" clearable
						style="width: 150px;">
						<el-option label="全部剂型" value=""></el-option>
						<el-option label="片剂" value="片剂"></el-option>
						<el-option label="胶囊" value="胶囊"></el-option>
						<el-option label="注射液" value="注射液"></el-option>
						<el-option label="颗粒剂" value="颗粒剂"></el-option>
						<el-option label="软膏" value="软膏"></el-option>
					</el-select>
				</el-form-item>

				<!-- <el-form-item label="业务日期：">
          <el-date-picker
            v-model="filterForm.dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            size="small"
            value-format="yyyy-MM-dd"
            style="width: 280px;"
          />
        </el-form-item> -->

				<!-- 修改库存筛选 -->
				<el-form-item>
					<el-checkbox v-model="filterForm.isHaveNum" style="margin-left: 10px;"
						@change="handleStockFilterChange">
						仅显示有库存
					</el-checkbox>
				</el-form-item>

				<el-form-item>
					<el-button type="primary" size="small" @click="handleFilter" icon="el-icon-Ssearch">
						查询
					</el-button>
					<el-button size="small" @click="resetFilter">
						重置
					</el-button>
				</el-form-item>
			</el-form>
		</div>

		<!-- 统计信息区域 -->
		<div class="stats-section">
			<el-tabs v-model="statsActiveTab" type="border-card" @tab-click="handleStatsTabClick">
				<el-tab-pane label="库存明细表" name="detail">
					<!-- 库存明细表内容 -->
					<div class="stats-content">
						<!-- 主表格和批次表格容器 -->
						<div class="table-container-wrapper" :class="{ 'batch-expanded': batchDetailVisible }">
							<!-- 主表格 -->
							<div class="main-table-section" :style="{ width: batchDetailVisible ? '50%' : '100%' }">
								<div class="table-section">
									<div class="table-header">
										<div class="table-stats">
										<!-- 	<div class="table-stat-item">
												<span class="stat-label">包装库存总数：</span>
												<span class="stat-value">{{ currentPageTotalStock }}</span>
											</div> -->
											<!-- <div class="table-stat-item">
												<span class="stat-label">销售总额：</span>
												<span class="stat-value">¥{{ totalCost }}</span>
											</div> -->
										</div>
									</div>

									<div class="table-container">
										<el-table :data="tableData" ref="singleTable" border stripe
											@row-dblclick="handledbRow" highlight-current-row
											@current-change="handleCurrentTableChange" v-loading="loading"
											style="width: 100%;" :height="tableHeight" :key="tableKey">

											<!-- 表格列保持不变... -->
											<el-table-column fixed="left" label="行号" type="index" width="60"
												align="center"></el-table-column>

											<el-table-column prop="drugType" label="药品类型" width="100" align="center">
												<template slot-scope="scope">
													<el-tag :type="getDrugTypeTagType(scope.row.drugType)" size="small">
														{{ statusMap[scope.row.drugType] }}
													</el-tag>
												</template>
											</el-table-column>

											<el-table-column prop="shedId" label="库房名称" width="120" align="center">
												<template slot-scope="{ row }">
													<span>{{ shedIdMap[row.shedId] || '未知' }}</span>
												</template>
											</el-table-column>

											<!-- <el-table-column prop="shedId" label="库房序号" width="90"
												align="center"></el-table-column> -->

											<el-table-column v-for="(col, inx) in tableRows" :key="inx" :type="col.type"
												:prop="col.prop" :label="col.name" :width="columnWidth(col, tableData)"
												:align="col.nz ? 'center' : 'left'" show-overflow-tooltip>
											</el-table-column>

											<el-table-column fixed="right" label="操作" width="100" align="center">
												<template slot-scope="scope">
													<el-button type="text" size="mini"
														@click="handleBatchDetail(scope.row)">
														批次明细
													</el-button>
												</template>
											</el-table-column>
										</el-table>
									</div>

									<!-- 分页 -->
									<div class="pagination-section">
										<el-pagination @size-change="handleSizeChange"
											@current-change="handleCurrentChange" :current-page="pageNum"
											:page-sizes="[10, 20, 50]" :page-size="pageSize" :total="totalSize"
											layout="total, sizes, prev, pager, next, jumper" background>
										</el-pagination>
									</div>
								</div>
							</div>

							<!-- 批次明细表格 -->
							<div class="batch-table-section" :class="{ 'expanded': batchDetailVisible }">
								<div class="batch-table-header">
									<div class="batch-table-title">
										<span>批次明细 - {{ currentBatchDrugName }}</span>
										<el-button type="text" icon="el-icon-close" size="mini"
											@click="closeBatchDetail" class="close-btn" />
									</div>
								</div>

								<div class="batch-table-container">
									<el-table :data="batchDetailData" v-loading="batchLoading" border stripe
										:height="tableHeight" style="width: 100%;">

										<el-table-column fixed="left" label="行号" type="index" width="60"
											align="center"></el-table-column>
										<!-- <el-table-column prop="code" label="药品编码" width="160"
											align="center"></el-table-column> -->
										<el-table-column prop="drugName" label="药品名称" width="150"
											show-overflow-tooltip></el-table-column>
										<el-table-column prop="purcCnt" label="库存数量" width="100"
											align="center"></el-table-column>
										<!-- <el-table-column prop="drugSpec" label="规格" width="120"
											align="center"></el-table-column> -->
										<el-table-column prop="manuDate" label="生产日期" width="120"
											align="center"></el-table-column>
										<el-table-column prop="expyDate" label="有效期至" width="120"
											align="center"></el-table-column>
										<el-table-column prop="manuLotnum" label="生产批号" width="120"
											align="center"></el-table-column>
										<el-table-column prop="prodentpName" label="生产厂家" width="150"
											show-overflow-tooltip></el-table-column>
										<el-table-column prop="supplierName" label="供货单位" width="120"
											align="center"></el-table-column>


										<el-table-column prop="purcAmt" label="成本总价" width="100" align="right">
											<template slot-scope="scope">
												¥{{ scope.row.purcAmt || '0.00' }}
											</template>
										</el-table-column>
										<el-table-column prop="saleAmt" label="零售总价" width="100" align="right">
											<template slot-scope="scope">
												¥{{ scope.row.saleAmt || '0.00' }}
											</template>
										</el-table-column>

										<el-table-column style="display: flex;" fixed="right" label="操作" width="300" align="center">
											<template slot-scope="scope">
												<el-button type="text" size="mini" @click="handleFlowRecord(scope.row)">
													流向记录
												</el-button>
												<!-- 新增价格调整按钮 -->
												<el-button type="danger" icon="el-icon-edit" size="mini"
													@click="handlePriceAdjust(scope.row)" class="price-adjust-btn">
													价格调整
												</el-button>
												<el-button type="primary" icon="el-icon-date" size="mini"
													@click="handleExpiryAdjust(scope.row)" class="expiry-adjust-btn">
													效期调整
												</el-button>
											</template>
										</el-table-column>
									</el-table>
								</div>

								<!-- 批次分页 -->
								<div class="batch-pagination-section">
									<el-pagination @size-change="handleBatchSizeChange"
										@current-change="handleBatchCurrentChange" :current-page="batchPageNum"
										:page-sizes="[10, 20, 50]" :page-size="batchPageSize" :total="batchTotalSize"
										layout="total, sizes, prev, pager, next, jumper" background small>
									</el-pagination>
								</div>
							</div>
						</div>
					</div>
				</el-tab-pane>
				<!-- 价格调整对话框 -->
				<el-dialog title="价格调整" :visible.sync="priceAdjustVisible" width="500px" top="10vh"
				    :before-close="priceAdjustHandleClose" class="price-adjust-dialog">
				
				    <div class="price-adjust-form">
				        <el-form :model="priceAdjustForm" :rules="priceAdjustRules" ref="priceAdjustForm"
				            label-width="120px">
				            <el-form-item label="药品名称" prop="name">
				                <el-input v-model="priceAdjustForm.name" :disabled="true" />
				            </el-form-item>
				
				            <el-form-item label="生产批号" prop="manuLotnum">
				                <el-input v-model="priceAdjustForm.manuLotnum" :disabled="true" />
				            </el-form-item>
				
				            <el-form-item label="库存类型" prop="purcType" required>
				                <el-radio-group v-model="priceAdjustForm.purcType">
				                    <el-radio :label="1">最小单位</el-radio>
				                    <el-radio :label="2">包装单位</el-radio>
				                </el-radio-group>
				            </el-form-item>
				
				            <el-form-item label="调整成本单价" prop="adjustPurcPric" required>
				                <el-input-number v-model="priceAdjustForm.adjustPurcPric" 
				                    :min="0" :precision="2" :step="0.01" 
				                    style="width: 100%;" />
				            </el-form-item>
				
				            <el-form-item label="调整销售单价" prop="adjustSalePric" required>
				                <el-input-number v-model="priceAdjustForm.adjustSalePric" 
				                    :min="0" :precision="2" :step="0.01" 
				                    style="width: 100%;" />
				            </el-form-item>
				        </el-form>
				    </div>
				
				    <span slot="footer" class="dialog-footer">
				        <el-button size="small" @click="priceAdjustVisible = false">取消</el-button>
				        <el-button size="small" type="primary" @click="handlePriceAdjustSubmit">确定</el-button>
				    </span>
				</el-dialog>
				<!-- 效期调整对话框 -->
				<el-dialog title="效期调整" :visible.sync="expiryAdjustVisible" width="500px" top="10vh"
					:before-close="expiryAdjustHandleClose" class="expiry-adjust-dialog">

					<div class="expiry-adjust-form">
						<el-form :model="expiryAdjustForm" :rules="expiryAdjustRules" ref="expiryAdjustForm"
							label-width="100px">
							<el-form-item label="药品名称" prop="name">
								<el-input v-model="expiryAdjustForm.name" :disabled="true" />
							</el-form-item>

							<el-form-item label="生产批号" prop="manuLotnum">
								<el-input v-model="expiryAdjustForm.manuLotnum" :disabled="true" />
							</el-form-item>

							<el-form-item label="生产日期" prop="manuDate">
								<el-date-picker v-model="expiryAdjustForm.manuDate" type="date" placeholder="选择生产日期"
									value-format="yyyy-MM-dd" style="width: 100%;" disabled />
							</el-form-item>

							<el-form-item label="有效期至" prop="expyDate">
								<el-date-picker v-model="expiryAdjustForm.expyDate" type="date" placeholder="选择有效期至"
									value-format="yyyy-MM-dd" style="width: 100%;" />
							</el-form-item>
						</el-form>
					</div>

					<span slot="footer" class="dialog-footer">
						<el-button size="small" @click="expiryAdjustVisible = false">取消</el-button>
						<el-button size="small" type="primary" @click="handleExpiryAdjustSubmit">确定</el-button>
					</span>
				</el-dialog>

				<el-tab-pane label="库存预警" name="warning" :disabled="true">
					<!-- 库存预警内容 -->
					<div class="stats-content">
						<!-- 表格区域 -->
						<div class="table-section">
							<!-- 预警表格头部 -->
							<!--              <div class="table-header">
                <div class="table-stats">
                  <div class="table-stat-item">
                    <span class="stat-label">预警总数：</span>
                    <span class="stat-value">{{ warningTotalSize }}</span>
                  </div>
                </div>
                
              </div> -->

							<!-- 预警筛选条件 -->
							<div class="warning-filter">
								<el-form :inline="true" :model="warningFilterForm" size="small">
									<el-form-item label="库房名称：">
										<el-select v-model="warningFilterForm.shedName" placeholder="请选择"
											style="width: 120px;">
											<el-option label="中药库" value="中药库"></el-option>
										</el-select>
									</el-form-item>

									<el-form-item label="药品类型：">
										<el-dropdown @command="handleWarningCommand" trigger="click">
											<span class="el-dropdown-link">
												{{ warningDropDownedName }}<i class="el-icon-down"></i>
											</span>
											<el-dropdown-menu slot="dropdown">
												<el-dropdown-item :command="v.command"
													v-for="(v,i) in warningDropdownMenu" :key="i">
													{{ v.label }}
												</el-dropdown-item>
												<el-dropdown-item command="e" divided>全部</el-dropdown-item>
											</el-dropdown-menu>
										</el-dropdown>
									</el-form-item>

									<el-form-item label="药品名称：">
										<el-input v-model="warningFilterForm.drugName" placeholder="编码、名称、拼音简码"
											style="width: 180px;" suffix-icon="el-icon-key" />
									</el-form-item>

									<el-form-item>
										<el-button type="primary" size="small" @click="handleWarningFilter"
											icon="el-icon-Ssearch">
											查询
										</el-button>
									</el-form-item>
									<div class="warning-buttons">
										<el-button size="small" @click="handleWarningRefresh">
											刷新
										</el-button>
										<el-button type="primary" size="small" @click="handleSetWarning">
											设置预警数量
										</el-button>
									</div>
								</el-form>
							</div>

							<!-- 预警表格 -->
							<div class="table-container">
								<el-table :data="warningTableData" border highlight-current-row
									v-loading="warningLoading" style="width: 100%;" :height="tableHeight"
									@current-change="handleWarningCurrentChange">

									<el-table-column fixed="left" label="行号" type="index" width="60"
										align="center"></el-table-column>

									<!-- <el-table-column prop="shedId" label="入库库房" width="120" align="center">
										<template slot-scope="{ row }">
											<span>{{ shedIdMap[row.shedId] || '未知' }}</span>
										</template>
									</el-table-column> -->

									<el-table-column v-for="(col, inx) in warningTableRows" :key="inx" :type="col.type"
										:prop="col.prop" :label="col.name"
										:width="warningColumnWidth(col, warningTableData)" align="center"
										show-overflow-tooltip>
									</el-table-column>
								</el-table>
							</div>

							<!-- 预警分页 -->
							<div class="pagination-section">
								<el-pagination @size-change="handleWarningSizeChange"
									@current-change="handleWarningCurrentChange" :current-page="warningPageNum"
									:page-sizes="[20, 50, 100]" :page-size="warningPageSize" :total="warningTotalSize"
									layout="total, sizes, prev, pager, next, jumper" background>
								</el-pagination>
							</div>
						</div>
					</div>
				</el-tab-pane>

				<el-tab-pane label="库存可视化图表" name="chart">
					<!-- 库存可视化图表内容 -->
					<div class="stats-content">
						<!-- 图表控制区域 -->
						<div class="chart-controls" style="display: flex;justify-content: space-between;">
							<div class="chart-type-selector">
								<el-radio-group v-model="chartType" size="small" @change="updateChart">
									<el-radio-button label="line">折线图</el-radio-button>
									<el-radio-button label="bar">柱状图</el-radio-button>
									<el-radio-button label="pie">饼图</el-radio-button>
									<el-radio-button label="treemap">树图</el-radio-button>
									<el-radio-button label="candlestick">K线图</el-radio-button>
								</el-radio-group>
							</div>

							<div class="chart-options">
								<el-select v-model="chartDataField" size="small" placeholder="选择数据字段"
									@change="updateChart">
									<el-option label="库存数量" value="purcCnt"></el-option>
									<el-option label="成本金额" value="purcAmt"></el-option>
									<el-option label="零售金额" value="saleAmt"></el-option>
									<el-option label="药品类型" value="drugType"></el-option>
								</el-select>

								<el-select v-model="chartGroupBy" size="small" placeholder="分组方式" @change="updateChart">
									<el-option label="按药品类型" value="drugType"></el-option>
									<el-option label="按库房" value="shedId"></el-option>
									<el-option label="按剂型" value="dosForm"></el-option>
								</el-select>

								<el-button size="small" icon="el-icon-refresh" @click="refreshChart">刷新</el-button>
								<el-button size="small" icon="el-icon-download" @click="downloadChart">导出</el-button>
							</div>
						</div>

						<!-- 图表容器 -->
						<div class="chart-container">
							<div id="inventoryChart" style="width: 100%; height: 500px;"></div>
						</div>

						<!-- 图表统计信息 -->
						<div class="chart-stats">
							<el-row :gutter="20">
								<el-col :span="6">
									<div class="stat-card">
										<div class="stat-title">药品总数</div>
										<div class="stat-value">{{ chartStats.totalDrugs }}</div>
									</div>
								</el-col>
								<el-col :span="6">
									<div class="stat-card">
										<div class="stat-title">库存总量</div>
										<div class="stat-value">{{ chartStats.totalStock }}</div>
									</div>
								</el-col>
								<el-col :span="6">
									<div class="stat-card">
										<div class="stat-title">成本总额</div>
										<div class="stat-value">¥{{ chartStats.totalCost }}</div>
									</div>
								</el-col>
								<el-col :span="6">
									<div class="stat-card">
										<div class="stat-title">平均库存</div>
										<div class="stat-value">{{ chartStats.avgStock }}</div>
									</div>
								</el-col>
							</el-row>
						</div>
					</div>
				</el-tab-pane>
			</el-tabs>
			<!-- </div> -->
		</div>

		<!-- 流向记录对话框 -->
		<el-dialog :title="'【' + flowDialogTitle + '】' + '药品流向记录'" :visible.sync="flowdiglog" width="70%" top="5vh"
			:before-close="flowhandleClose" class="flow-dialog">

			<div class="dialog-header">
				<span>业务日期:</span>
				<el-date-picker v-model="startDate" type="datetime" size="small" style="margin-left: 8px; width: 180px;"
					placeholder="选择开始时间" :picker-options="pickerOptions" @change="startDateHandle"
					value-format="yyyy-MM-dd HH:mm:ss">
				</el-date-picker>
				<el-date-picker v-model="endDate" type="datetime" style="margin-left: 8px; width: 180px;" size="small"
					placeholder="选择结束时间" :picker-options="pickerOptions" @change="endDateHandle"
					value-format="yyyy-MM-dd HH:mm:ss">
				</el-date-picker>
				<el-button size="small" type="primary" plain @click="changeData" style="margin-left: 8px;">
					刷新
				</el-button>
			</div>

			<div class="dialog-table">
				<el-table :data="innertableData" v-loading="loading" ref="singleTable" border
					@row-dblclick="handledbRow" highlight-current-row @current-change="handleCurrentTableChange"
					height="400">

					<el-table-column prop="id" label="系统序号" width="80" align="center"></el-table-column>
					<el-table-column prop="drugName" label="药品名称" width="150" show-overflow-tooltip></el-table-column>
					<el-table-column prop="shedId" label="入库库房" width="120" align="center">
						<template slot-scope="{ row }">
							<span>{{ shedIdMap[row.shedId] || '未知' }}</span>
						</template>
					</el-table-column>

					<el-table-column prop="bizSouc" label="业务来源" width="120" align="center">
						<template slot-scope="{ row }">
							<span :style="{ color: bizColorMap[row.bizSouc] }">{{ bizMap[row.bizSouc] || '未知' }}</span>
						</template>
					</el-table-column>
					<el-table-column prop="chgCnt" label="库存变化数量" width="160" show-overflow-tooltip></el-table-column>

					<el-table-column v-for="(col, inx) in innertableDataRows" :key="inx" :type="col.type"
						:prop="col.prop" :label="col.name" :width="flowdiglogColumnWidth(col, innertableData)"
						align="center">
					</el-table-column>
				</el-table>
			</div>

			<div class="dialog-pagination">
				<el-pagination @size-change="innerHandleSizeChange" @current-change="innerHandleCurrentChange"
					:current-page="pageNum" :page-sizes="[10, 20, 50]" :page-size="innerPageSize"
					:total="innerTotolSize" layout="total, sizes, prev, pager, next, jumper" background size="small">
				</el-pagination>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button size="small" type="primary" @click="dy">打印</el-button>
				<el-button size="small" @click="flowdiglog = false">关闭</el-button>
			</span>
		</el-dialog>



		<!-- 设置预警数量对话框 -->
		<el-dialog title="库存预警编辑[中药]" :visible.sync="warningEditVisible" width="70%" top="5vh"
			:before-close="warningEditHandleClose" class="warning-edit-dialog">

			<div class="warning-edit-table">
				<el-table :data="warningEditTableData" border highlight-current-row v-loading="warningLoading"
					height="400" :cell-class-name="warningTableCellClassName" @row-dblclick="warningEditDbClick">

					<el-table-column fixed="left" label="行号" type="index" width="60" align="center"></el-table-column>

					<el-table-column prop="shedId" label="入库库房" width="120" align="center">
						<template slot-scope="{ row }">
							<span>{{ shedIdMap[row.shedId] || '未知' }}</span>
						</template>
					</el-table-column>

					<el-table-column prop="drugCode" label="药品编码" width="128" align="center"></el-table-column>
					<el-table-column prop="drugName" label="药品名称" width="150" show-overflow-tooltip></el-table-column>
					<el-table-column prop="drugSpec" label="规格描述" width="200" show-overflow-tooltip></el-table-column>
					<el-table-column prop="prodentpName" label="生产厂家" width="150"
						show-overflow-tooltip></el-table-column>
					<el-table-column prop="purcCnt" label="库存数量" width="100" align="center"></el-table-column>
					<el-table-column prop="unit" label="药品单位" width="100" align="center"></el-table-column>

					<el-table-column prop="cntLow" label="最低库存数量" width="130" align="center">
						<template slot-scope="scope">
							<el-input size="mini" v-model="scope.row.cntLow"
								:ref="`warning_${scope.row.index}_${scope.column.index}`"
								v-if="`warning_${scope.row.index}_${scope.column.index}` === warningCurrentCell"
								@blur="warningEditHideInput(scope.row)" placeholder="请输入" />
							<span v-else>{{ scope.row.cntLow }}</span>
						</template>
					</el-table-column>

					<el-table-column prop="cntHigh" label="最高库存数量" width="130" align="center">
						<template slot-scope="scope">
							<el-input size="mini" v-model="scope.row.cntHigh"
								:ref="`warning_${scope.row.index}_${scope.column.index}`"
								v-if="`warning_${scope.row.index}_${scope.column.index}` === warningCurrentCell"
								@blur="warningEditHighHideInput(scope.row)" placeholder="请输入" />
							<span v-else>{{ scope.row.cntHigh }}</span>
						</template>
					</el-table-column>

					<el-table-column prop="repairPurcCnt" label="应补库存数" width="100" align="center"></el-table-column>
					<el-table-column prop="pharmacyCnt" label="药房库存数" width="100" align="center"></el-table-column>
				</el-table>
			</div>

			<div class="warning-edit-pagination">
				<el-pagination @size-change="handleWarningEditSizeChange"
					@current-change="handleWarningEditCurrentChange" :current-page="warningEditPageNum"
					:page-sizes="[10, 20, 50]" :page-size="warningEditPageSize" :total="warningEditTotalSize"
					layout="total, sizes, prev, pager, next, jumper" background size="small">
				</el-pagination>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button :loading="warningLoading" size="small" @click="warningEditVisible = false">取 消</el-button>
				<el-button :loading="warningLoading" size="small" type="primary" @click="warningEditSubmit">确
					定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	// 导入ECharts
	import * as echarts from 'echarts';
	import printUtil from "@/untils/printUtil";
	import {
		Winvent
	} from "@/assets/printTemplateConfig/Winvent";
	import {
		getZYInventPage,
		ZYchgDetails
	} from "@/api/PSI/DrugInventory.js";
	import {
		getZYBatchNumber,
		updateZYDate
	} from "@/api/PSI/DrugInventory.js";
	// 调价相关接口
	import { chgZYDetailsPageric,adjustZYastPric } from "@/api/PSI/ChangeDetailsTable.js";
	// 导入库存预警相关接口
	import {
		alertListZYK,
		alertPagesZYK,
		alertZYK
	} from "@/api/PSI/westernWarning.js";
	// 药品剂型相关
	import {
		getDosageForm
	} from "@/api/PSI.js";

	export default {
		name: 'Zyk',
		props: {
			// 接收父组件传递的库存类型
			inventoryType: {
				type: String,
				default: 'western'
			}
		},
		data() {
			return {
				// 统计信息选项卡
				statsActiveTab: 'detail',
				// 筛选条件数据 - 修改默认值
				filterForm: {
					drugName: '',
					dosform: '',
					dateRange: [],
					isHaveNum: true // 默认勾选"仅显示有库存"
				},
				// 价格调整相关数据
				        priceAdjustVisible: false,
				        priceAdjustForm: {
				            name: '',
				            manuLotnum: '',
				            adjustPurcPric: 0,
				            adjustSalePric: 0,
				            drugId: 0,
				            purcId: 0,
				            purcType: 1 // 默认选择最小单位
				        },
				        priceAdjustRules: {
				            adjustPurcPric: [
				                { required: true, message: '请输入调整成本单价', trigger: 'blur' },
				                { type: 'number', min: 0, message: '成本单价不能为负数', trigger: 'blur' }
				            ],
				            adjustSalePric: [
				                { required: true, message: '请输入调整销售单价', trigger: 'blur' },
				                { type: 'number', min: 0, message: '销售单价不能为负数', trigger: 'blur' }
				            ],
				            purcType: [
				                { required: true, message: '请选择库存类型', trigger: 'change' }
				            ]
				        },
				        currentPriceRow: null, // 当前价格调整的行数据
				// 统计信息数据
				totalStock: '0',
				totalInventoryCount: 0,
				totalCost: '0.00',
				currentPageTotalStock: '0', // 修改为当前页库存总数
				// 表格数据
				tableHeight: 400,
				pageNum: 1,
				pageSize: 10,
				totalSize: 0,
				tableData: [],
				tableKey: Date.now(), // 用于强制重新渲染表格
				// 效期调整相关数据
				expiryAdjustForm: {
					name: '',
					manuLotnum: '',
					manuDate: '',
					expyDate: ''
				},
				expiryAdjustRules: {
					manuDate: [{
						required: true,
						message: '请选择生产日期',
						trigger: 'change'
					}],
					expyDate: [{
						required: true,
						message: '请选择有效期至',
						trigger: 'change'
					}]
				},
				currentExpiryRow: null, // 当前效期调整的行数据
				// 对话框控制
				flowdiglog: false,
				batchDetailVisible: false,
				warningEditVisible: false,
				expiryAdjustVisible: false,
				flowDialogTitle: '',
				batchDetailData: [],

				// 其他数据
				startDate: '',
				endDate: '',
				flowId: '',
				manuLotnum: '',
				loading: false,
				innerPageSize: 10,
				innerTotolSize: 20,
				currentTable: {},
				innertableData: [],

				// 库存预警相关数据
				warningLoading: false,
				warningPageNum: 1,
				warningPageSize: 20,
				warningTotalSize: 0,
				warningTableData: [],
				warningEditTableData: [],
				warningEditPageNum: 1,
				warningEditPageSize: 10,
				warningEditTotalSize: 0,
				warningCurrentCell: null,
				warningSubmitData: {},

				// 预警筛选条件
				warningFilterForm: {
					shedName: '中药库',
					name: ''
				},
				warningDropDownedName: '全部',
				warningDropdownMenu: [{
						id: 1,
						label: '卫材',
						command: 'a'
					},
					{
						id: 2,
						label: '疫苗',
						command: 'b'
					},
					{
						id: 3,
						label: '中成药',
						command: 'c'
					},
					{
						id: 4,
						label: '中药',
						command: 'd'
					}
				],

				// 预警表格列配置
				warningTableRows: [{
						name: "药品编码",
						prop: "drugCode",
						type: ""
					},
					{
						name: "药品名称",
						prop: "drugName",
						type: ""
					},
					{
						name: "规格描述",
						prop: "drugSpec",
						type: ""
					},
					{
						name: "生产厂家",
						prop: "prodentpName"
					},
					{
						name: "库存数量",
						prop: "purcCnt",
						type: ""
					},
					{
						name: "药品单位",
						prop: "unit"
					},
					{
						name: "最低库存数",
						prop: "cntLow",
						type: ""
					},
					{
						name: "最高库存数",
						prop: "cntHigh",
						type: ""
					},
					{
						name: "应补库存数",
						prop: "repairPurcCnt"
					},
					{
						name: "药房库存数",
						prop: "pharmacyCnt",
						type: ""
					}
				],

				// 图表相关数据
				chart: null, // ECharts实例
				chartType: 'line', // 当前图表类型
				chartDataField: 'purcCnt', // 当前数据字段
				chartGroupBy: 'drugType', // 分组方式
				chartStats: {
					totalDrugs: 0,
					totalStock: 0,
					totalCost: '0.00',
					avgStock: 0
				},
				// 映射数据（添加更多映射）
				drugTypeMap: {
					1: '中药',
					2: '成药',
					3: '卫材',
					4: '血液',
					5: '疫苗'
				},
				dosformMap: {
					'片剂': '片剂',
					'胶囊': '胶囊',
					'注射液': '注射液',
					'颗粒剂': '颗粒剂',
					'软膏': '软膏'
				},
				// 映射数据
				shedIdMap: {
					1: '中药库',
					2: '中药库',
					3: '中药房',
					4: '中药房'
				},
				bizMap: {
					1: '采购入库',
					2: '其他入库',
					3: '冲销入库',
					4: '调拨出库',
					5: '出库',
					6: '盘点入库',
					7: '盘点反结转入库',
					8: '发药入库',
					9: '退药入库',
					10: '调拨入库',
					// 11: '采购退库',
					// 12: '报损出库',
					// 13: '过期出库',
					// 14: '捐赠出库',
					// 15: '其他出库',
					// 16: '输错出库',
					// 17: '科室出库',
					// 18: '销售出库',
					// 19: '拆零自动出库'
				},
				bizColorMap: {
					1: '#67C23A',
					2: '#409EFF',
					3: '#F56C6C',
					4: '#FF6700',
					5: '#aa0000',
					6: '#F56C6C',
					7: '#FF6700',
					8: '#67C23A',
					9: '#aa0000'
				},
				statusMap: {
					1: '中药',
					2: '成药',
					3: '卫材',
					4: '血液',
					5: '疫苗'
				},
				// 批次明细相关数据
				// batchDetailVisible: false, // 控制批次表格显示
				currentBatchDrug: null, // 当前选中的药品
				currentBatchDrugName: '', // 当前药品名称
				batchLoading: false, // 批次表格加载状态
				batchPageNum: 1, // 批次当前页
				batchPageSize: 10, // 批次每页大小
				batchTotalSize: 0, // 批次总条数
				// batchDetailData: [],      // 批次数据
				// 表格列配置
				tableRows: [{
						name: "药品名称",
						prop: "drugName",
						type: ""
					},
					{
						name: "药品编码",
						prop: "code",
						type: ""
					},
					{
						name: "药品剂型",
						prop: "dosForm",
						type: ""
					},
					{
						name: "规格描述",
						prop: "drugSpec",
						type: ""
					},
					{
						name: "成本总金额",
						prop: "allPurcAmt",
					},
					{
						name: "销售总金额",
						prop: "allSaleAmt",
					},
					{
						name: "实际库存数量",
						prop: "allRealCnt"
					},

					{
						name: "冻结库存数量",
						prop: "allFreezeCnt",
					},

				],
				innertableDataRows: [{
						name: "创建时间",
						prop: "createTime",
						type: ""
					},

					{
						name: "变化前库",
						prop: "agoCnt",
						type: ""
					},
					{
						name: "变化后库",
						prop: "afrCnt",
						type: ""
					},
					{
						name: "计量单位",
						prop: "unt",
						type: ""
					},
					{
						name: "成本单价",
						prop: "purcPric",
						type: ""
					},
					{
						name: "零售单价",
						prop: "salePric",
						type: ""
					},
					{
						name: "药品规格",
						prop: "drugSpec",
						type: ""
					},
					{
						name: "生产厂家",
						prop: "prodentpName",
						type: ""
					},
					{
						name: "生产批号",
						prop: "manuLotnum",
						type: ""
					}
				],

				pickerOptions: {
					shortcuts: [{
							text: '今天',
							onClick(picker) {
								picker.$emit('pick', new Date());
							}
						},
						{
							text: '昨天',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24);
								picker.$emit('pick', date);
							}
						},
						{
							text: '一周前',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
								picker.$emit('pick', date);
							}
						},
						{
							text: '最近一个月',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24 * 30);
								picker.$emit('pick', date);
							}
						},
						{
							text: '最近三个月',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24 * 90);
								picker.$emit('pick', date);
							}
						},
						{
							text: '半年前',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24 * 180);
								picker.$emit('pick', date);
							}
						},
						{
							text: '去年',
							onClick(picker) {
								const date = new Date();
								date.setTime(date.getTime() - 3600 * 1000 * 24 * 360);
								picker.$emit('pick', date);
							}
						}
					]
				}
			};
		},
		watch: {
			// 监听库存类型变化，重新加载数据
			inventoryType: {
				immediate: true,
				handler(newVal) {
					this.loadData(); // loadData中已经包含传递逻辑
				}
			},

			// 监听统计信息选项卡变化
			statsActiveTab: {
				handler(newVal) {
					if (newVal === 'chart') {
						// 切换到图表标签时初始化图表
						this.$nextTick(() => {
							this.initChart();
							this.updateChart();
						});
					}
				}
			},
		},

		mounted() {
			this.loadData(); // 初始加载数据
			this.getDateTime();
			this.calculateTableHeight();
			this.$nextTick(() => {
				window.addEventListener('resize', this.calculateTableHeight);
			});

			// 确保图表初始化
			this.$nextTick(() => {
				if (this.statsActiveTab === 'chart') {
					this.initChart();
				}
			});
		},
		beforeDestroy() {
			window.removeEventListener('resize', this.calculateTableHeight);
			// 销毁图表实例
			if (this.chart) {
				this.chart.dispose();
				this.chart = null;
			}
		},
		methods: {
			// 处理未设置库存复选框变化
			handleNoStockChange(value) {
				console.log('未设置库存筛选:', value);
				this.pageNum = 1;
				this.loadData();
			},

			// 加载数据方法
			async loadData() {
				this.loading = true;
				try {
					let params = {
						pageNum: this.pageNum,
						pageSize: this.pageSize,
						dosform: this.filterForm.dosform,
						drugName: this.filterForm.drugName,
					};
					
					// 修改库存筛选逻辑
					// 默认 isHaveNum 为 true，isHaveNum 为 1（有库存）
					// 当取消勾选时，isHaveNum 为 false，isHaveNum 为 0（无库存）
					if (this.filterForm.isHaveNum !== undefined) {
						params.isHaveNum = this.filterForm.isHaveNum ? 1 : 0;
					}

					let res = await getZYInventPage(params);

					if (res.code === 200) {
						this.tableData = res.data.content.map(item => {
							return {
								...item,
								shedId: 1,
								drugType: 1,
								pacUntCnt: (item.pacUntCnt || 0) + (item.pacUnt || 0) + (item.dosUntCnt || 0) +
									(item.dosUnt || 0),
							};
						});

						this.totalSize = res.data.totalSize;

						// 计算总库存数量（根据实际业务逻辑调整）
						this.totalInventoryCount = this.calculateTotalInventoryCount(this.tableData);

						// 立即向父组件传递库存数量
						this.$emit('count-update', {
							type: this.inventoryType,
							count: this.totalInventoryCount
						});

						this.updateStatistics();

						this.$nextTick(() => {
							this.forceTableRerender();
						});
					} else {
						this.$message.error(res.message || '获取数据失败');
					}
				} catch (error) {
					this.$message.error('请求出错: ' + error.message);
				} finally {
					this.loading = false;
				}
			},
			// 根据库存类型获取对应的API参数
			getStoreType() {
				const typeMap = {
					'western': '1', // 西药库
					'chinese': '2', // 中药库
					'western-room': '3', // 西药房
					'chinese-room': '4' // 中药房
				};
				return typeMap[this.inventoryType] || '1';
			},
			// 计算总库存数量
			calculateTotalInventoryCount(tableData) {
				if (!tableData || tableData.length === 0) {
					return 0;
				}

				// 根据实际业务逻辑计算总库存数量
				// 这里假设使用allRealCnt字段，您可以根据实际情况调整
				return tableData.reduce((total, item) => {
					return total + (Number(item.allRealCnt) || 0);
				}, 0);
			},

			// 根据库存类型获取对应的API参数
			getisHaveNum() {
				const typeMap = {
					'western': 1, // 西药库
					'chinese': 2, // 中药库
					'western-room': 3, // 西药房
					'chinese-room': 4 // 中药房
				};
				return typeMap[this.inventoryType] || 1;
			},

			// 强制表格重新渲染
			forceTableRerender() {
				this.tableKey = Date.now();
			},

			// 更新统计信息方法
			updateStatistics() {
				if (this.tableData.length > 0) {
					// 当前页库存总数（用于页面显示）
					const pageStock = this.tableData.reduce((sum, item) => sum + (Number(item.allPurcAmt) || 0), 0);
					const totalCost = this.tableData.reduce((sum, item) => sum + parseFloat(item.allSaleAmt || 0), 0);

					this.currentPageTotalStock = pageStock.toLocaleString();
					this.totalCost = totalCost.toFixed(2);

					// 计算总库存数量（用于传递给父组件）
					this.totalInventoryCount = this.calculateTotalInventoryCount(this.tableData);
				} else {
					this.currentPageTotalStock = '0';
					this.totalCost = '0.00';
					this.totalInventoryCount = 0;
				}
			},

			// 批次明细表格中的效期调整按钮点击
			handleExpiryAdjust(row) {
				this.currentExpiryRow = row;
				this.expiryAdjustForm = {
					drugName: row.drugName || '',
					manuLotnum: row.manuLotnum || '',
					manuDate: row.manuDate || '',
					expyDate: row.expyDate || ''
				};
				this.expiryAdjustVisible = true;
			},

			// 效期调整提交
			async handleExpiryAdjustSubmit() {
				try {
					this.$refs.expiryAdjustForm.validate(async (valid) => {
						if (valid) {
							this.loading = true;

							// 检查日期逻辑
							if (this.expiryAdjustForm.manuDate && this.expiryAdjustForm.expyDate) {
								const manuDate = new Date(this.expiryAdjustForm.manuDate);
								const expyDate = new Date(this.expiryAdjustForm.expyDate);

								if (manuDate > expyDate) {
									this.$message.error('生产日期不能晚于有效期至');
									return;
								}
							}

							// 准备请求参数
							const params = {
								id: this.currentExpiryRow.id,
								manuDate: this.expiryAdjustForm.manuDate,
								expyDate: this.expiryAdjustForm.expyDate
							};

							const res = await updateZYDate(params);

							if (res.code === 200) {
								this.$message.success('效期调整成功');
								this.expiryAdjustVisible = false;

								// 刷新批次数据
								if (this.currentBatchDrug) {
									await this.handleBatchDetail(this.currentBatchDrug);
								}
							} else {
								this.$message.error(res.message || '效期调整失败');
							}
						} else {
							this.$message.error('请填写完整的效期信息');
						}
					});
				} catch (error) {
					console.error('效期调整出错:', error);
					this.$message.error('效期调整出错');
				} finally {
					this.loading = false;
				}
			},

			// 效期调整对话框关闭
			expiryAdjustHandleClose(done) {
				this.$confirm('确认关闭？未保存的修改将丢失。', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.expiryAdjustVisible = false;
					if (done) done();
				}).catch(() => {
					this.$message.info('已取消关闭');
				});
			},
			// 价格调整按钮点击
			    handlePriceAdjust(row) {
			        this.currentPriceRow = row;
			        this.priceAdjustForm = {
			            drugName: row.drugName || '',
			            manuLotnum: row.manuLotnum || '',
			            adjustPurcPric: Number(row.purcPric) || 0,
			            adjustSalePric: Number(row.salePric) || 0,
			            drugId: row.drugId || row.id,
			            purcId: row.id,
			            purcType: 1 // 默认选择最小单位
			        };
			        this.priceAdjustVisible = true;
			        
			        // 重置表单验证
			        this.$nextTick(() => {
			            if (this.$refs.priceAdjustForm) {
			                this.$refs.priceAdjustForm.clearValidate();
			            }
			        });
			    },
			
			    // 价格调整提交
			    async handlePriceAdjustSubmit() {
			        try {
			            this.$refs.priceAdjustForm.validate(async (valid) => {
			                if (valid) {
			                    this.loading = true;
			
			                    // 准备请求参数
			                    const params = {
			                        adjustPurcPric: this.priceAdjustForm.adjustPurcPric,
			                        adjustSalePric: this.priceAdjustForm.adjustSalePric,
			                        drugId: this.priceAdjustForm.drugId,
			                        purcId: this.priceAdjustForm.purcId,
			                        purcType: this.priceAdjustForm.purcType
			                    };
			
			                    // 调用价格调整接口
			                    const res = await adjustZYastPric(params);
			
			                    if (res.code === 200) {
			                        this.$message.success('价格调整成功');
			                        this.priceAdjustVisible = false;
			
			                        // 刷新批次数据
			                        if (this.currentBatchDrug) {
			                            await this.handleBatchDetail(this.currentBatchDrug);
			                        }
			                    } else {
			                        this.$message.error(res.message || '价格调整失败');
			                    }
			                } else {
			                    this.$message.error('请填写完整的价格信息');
			                    return false;
			                }
			            });
			        } catch (error) {
			            console.error('价格调整出错:', error);
			            this.$message.error('价格调整出错');
			        } finally {
			            this.loading = false;
			        }
			    },
				// 处理库存筛选变化
				handleStockFilterChange(value) {
				  console.log('库存筛选变更:', { 
				    当前状态: value ? '仅显示有库存' : '显示所有库存',
				    接口参数: value ? 'IsNum=1' : 'IsNum=0'
				  });
				  this.pageNum = 1; // 重置到第一页
				  this.loadData();
				},
			    // 价格调整对话框关闭
			    priceAdjustHandleClose(done) {
			        this.$confirm('确认关闭？未保存的修改将丢失。', '提示', {
			            confirmButtonText: '确定',
			            cancelButtonText: '取消',
			            type: 'warning'
			        }).then(() => {
			            this.priceAdjustVisible = false;
			            if (done) done();
			        }).catch(() => {
			            this.$message.info('已取消关闭');
			        });
			    },
			// 处理查询
			handleFilter() {
				this.pageNum = 1;
				this.loadData(); // loadData中已经包含传递逻辑
			},

			// 重置筛选条件
			resetFilter() {
			  this.filterForm = {
			    drugName: '',
			    dosform: '',
			    dateRange: [],
			    hasStock: true  // 重置为默认值（仅显示有库存）
			  };
			  this.pageNum = 1;
			  this.loadData();
			},

			// 分页处理
			handleSizeChange(val) {
				this.pageNum = 1;
				this.pageSize = val;
				this.loadData(); // loadData中已经包含传递逻辑
			},

			handleCurrentChange(val) {
				this.pageNum = val;
				this.loadData(); // loadData中已经包含传递逻辑
			},

			// 计算表格高度
			calculateTableHeight() {
				const windowHeight = window.innerHeight;
				const otherHeight = 500;
				this.tableHeight = Math.max(400, windowHeight - otherHeight);
			},

			// 获取药品类型标签样式
			getDrugTypeTagType(type) {
				const typeMap = {
					1: 'success',
					2: 'warning',
					3: 'info',
					4: 'danger',
					5: 'primary'
				};
				return typeMap[type] || 'info';
			},

			// 批次明细按钮点击 - 修改为展开内联表格
			async handleBatchDetail(row) {
				try {
					this.batchLoading = true;
					this.currentBatchDrug = row;
					this.currentBatchDrugName = row.drugName || '药品';

					// 加载批次数据
					const res = await getZYBatchNumber({
						drugId: row.drugId || row.id,
						pageNum: this.batchPageNum,
						pageSize: this.batchPageSize
					});

					if (res.code === 200) {
						this.batchDetailData = res.data.content || res.data;
						this.batchTotalSize = res.data.totalSize || res.data.length;

						// 显示内联批次表格
						this.batchDetailVisible = true;
					} else {
						this.$message.error(res.message || '获取批次数据失败');
					}
				} catch (error) {
					console.error('获取批次数据出错:', error);
					this.$message.error('获取批次数据出错');
				} finally {
					this.batchLoading = false;
				}
			},

			// 关闭批次明细 - 修改为隐藏内联表格
			closeBatchDetail() {
				this.batchDetailVisible = false;
				this.currentBatchDrug = null;
				this.currentBatchDrugName = '';
				this.batchDetailData = [];
				this.batchPageNum = 1;
				this.batchTotalSize = 0;
			},

			// 批次分页大小改变
			handleBatchSizeChange(val) {
				this.batchPageSize = val;
				this.batchPageNum = 1;
				if (this.currentBatchDrug) {
					this.handleBatchDetail(this.currentBatchDrug);
				}
			},

			// 批次当前页改变
			handleBatchCurrentChange(val) {
				this.batchPageNum = val;
				if (this.currentBatchDrug) {
					this.handleBatchDetail(this.currentBatchDrug);
				}
			},

			// 从批次表格点击流向记录
			handleFlowRecordFromBatch(row) {
				console.log('批次明细流向记录参数:', {
					purcId: row.id, // 库存序号
					pageNum: this.flowPageNum, // 当前页码
					pageSize: this.flowPageSize, // 每页大小
				});

				this.flowDialogTitle = row.name || this.currentBatchDrugName;
				this.flowdiglog = true;
				this.flowId = row.id || row.drugId;
				this.manuLotnum = row.manuLotnum;

				// 重置流向记录分页参数
				this.flowPageNum = 1;
				this.flowPageSize = 10;

				this.getFlowData();
			},

			handleFlowRecord(row) {
				console.log('主表格流向记录参数:', {
					row,
					purcId: row.id, // 库存序号
					pageNum: this.pageNum, // 当前页码
					pageSize: this.pageSize, // 每页大小
				});

				this.flowDialogTitle = row.name || '药品';
				this.flowdiglog = true;
				this.flowId = row.id || row.purcId;
				this.manuLotnum = row.manuLotnum;

				// 重置流向记录分页参数
				this.pageNum = 1;
				this.pageSize = 10;

				this.getFlowData();
			},

			// 获取批次号数据
			async getBatchNumberData(row) {
				try {
					this.loading = true;
					const res = await getZYBatchNumber({
						drugId: row.drugId || row.id
					});

					if (res.code === 200) {
						this.batchDetailData = res.data;
						this.batchDetailVisible = true;
					} else {
						this.$message.error(res.message || '获取批次号数据失败');
					}
				} catch (error) {
					console.error('获取批次号数据出错:', error);
					this.$message.error('获取批次号数据出错');
				} finally {
					this.loading = false;
				}
			},

			// 获取流向数据
			async getFlowData() {
				if (!this.flowId) {
					this.$message.error('缺少药品ID参数');
					return;
				}

				try {
					this.loading = true;

					// 构建正确的参数对象
					let params = {
						purcId: this.flowId, // 库存序号
						pageNum: this.pageNum, // 当前页码
						pageSize: this.pageSize, // 每页大小
					};

					console.log('调用ZYchgDetails接口参数:', params);

					let res = await ZYchgDetails(params);

					if (res.code === 200) {
						this.innertableData = res.data.content || res.data;
						this.innerTotolSize = res.data.totalSize || (res.data.content ? res.data.content.length : 0);
						this.$message.success('获取流向记录成功');
					} else {
						this.$message.error(res.message || '获取流向记录失败');
					}
				} catch (error) {
					console.error('获取流向记录出错:', error);
					this.$message.error('获取流向记录出错: ' + error.message);
				} finally {
					this.loading = false;
				}
			},

			// 获取当前时间
			getDateTime() {
				const today = new Date();
				const startDate = new Date(today);
				startDate.setHours(0, 0, 0, 0);
				this.startDate = this.formatDateTime(startDate);

				const endDate = new Date(today);
				endDate.setHours(23, 59, 59, 999);
				this.endDate = this.formatDateTime(endDate);
			},

			// 格式化日期时间
			formatDateTime(date) {
				const year = date.getFullYear();
				const month = String(date.getMonth() + 1).padStart(2, '0');
				const day = String(date.getDate()).padStart(2, '0');
				const hours = String(date.getHours()).padStart(2, '0');
				const minutes = String(date.getMinutes()).padStart(2, '0');
				const seconds = String(date.getSeconds()).padStart(2, '0');

				return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
			},

			// 处理统计信息选项卡点击
			handleStatsTabClick(tab) {
				console.log('切换到统计信息标签:', tab.name);
			},

			// 流向记录分页大小改变
			innerHandleSizeChange(val) {
				this.flowPageSize = val;
				this.flowPageNum = 1;
				this.getFlowData();
			},

			// 流向记录当前页改变
			innerHandleCurrentChange(val) {
				this.flowPageNum = val;
				this.getFlowData();
			},

			// 其他方法保持不变...
			handledbRow(row, column, event) {
				// console.log(this.addForm);
			},

			handleCurrentTableChange(val) {
				this.currentTable = val;
			},

			changeData() {
				this.getFlowData();
			},

			// 列宽计算等方法保持不变...
			// col 里面包含了表头字段和名称，list 是表格数据
			columnWidth(col, list) {
				let prop = col.prop,
					lab = col.lab;
				let width = 20; // 设定一个最小值
				let maxlenStr = ""; // 最长字符串
				for (let info of list) {
					if (maxlenStr < (info[prop] + "").length) maxlenStr = info[prop];
				}
				width = Math.max(width, len(lab), len(maxlenStr));
				// 表格自带的内边距(20px) 自调
				return width + 12; // 这里加了 12px
				function len(str) {
					// 实际分配长度可根据需要自行调整
					let length = 8;
					for (const char of str + "") {
						// 英文小写字符 8px
						if ("a" <= char && char <= "z") length += 12;
						// 英文大写字符 8px
						else if ("A" <= char && char <= "Z") length += 8;
						// 数字
						else if (Number.isFinite(Number(char))) length += 8;
						// 中文字符 28px
						else if (char >= "\u4e00" && char <= "\u9fa5") length += 26;
						// 其他 8px
						else length += 12;
					}
					return length;
				}
			},

			flowdiglogColumnWidth(col, list) {
				let prop = col.prop,
					lab = col.lab;
				let width = 28; // 设定一个最小值
				let maxlenStr = ""; // 最长字符串
				for (let info of list) {
					if (maxlenStr < (info[prop] + "").length) maxlenStr = info[prop];
				}
				width = Math.max(width, len(lab), len(maxlenStr));
				// 表格自带的内边距(20px) 自调
				return width + 20; // 这里加了 12px
				function len(str) {
					// 实际分配长度可根据需要自行调整
					let length = 12;
					for (const char of str + "") {
						// 英文小写字符 8px
						if ("a" <= char && char <= "z") length += 8;
						// 英文大写字符 8px
						else if ("A" <= char && char <= "Z") length += 8;
						// 数字
						else if (Number.isFinite(Number(char))) length += 12;
						// 中文字符 28px
						else if (char >= "\u4e00" && char <= "\u9fa5") length += 22;
						// 其他 8px
						else length += 12;
					}
					return length;
				}
			},


			// 修改 TZXQhandleCurrent 方法
			TZXQhandleCurrent(val) {
				if (val) {
					this.TZXQcurrentTable = {
						...val
					}; // 使用对象展开创建新对象
					this.flowId = val.drugId;
					this.manuLotnum = val.manuLotnum;
				} else {
					this.TZXQcurrentTable = {}; // 重置为空对象
				}
			},

			// see table
			// 表格底部循环按钮事件
			feetHandClick(i) {
				// i event
				switch (i) {
					case 0:
						// 批次号显示
						if (!this.currentTable || Object.keys(this.currentTable).length === 0) {
							this.$message.warning('请先选择一条数据');
							return;
						}

						// 高亮显示选中的行
						this.$nextTick(() => {
							const table = this.$refs.singleTable;
							if (table) {
								table.setCurrentRow(this.currentTable);
							}
						});

						// 调用接口获取批次号数据
						this.getBatchNumberData();
						break;
					case 1:
						// 流向记录
						this.$message({
							type: 'warning',
							message: '流向记录'
						});
						break;
					case 2:
						// this.handlePrint();
						break;
					case 3:
						this.$message({
							type: 'warning',
							message: '暂未开放，敬请期待。'
						});
						break;
				}
			},

			// 修改流向记录按钮点击逻辑
			XQfeetHandClick(v) {
				console.log(v, '日期调整等按钮');
				if (v.title == '档案信息' || v.title.includes('档案信息')) {
					this.$message({
						type: 'warning',
						message: '档案信息'
					});
				} else if (v.title == '流向记录' || v.title.includes('流向记录')) {
					// 确保有选中行
					if (!this.TZXQcurrentTable || Object.keys(this.TZXQcurrentTable).length === 0) {
						this.$message.warning('请先选择一条批次数据');
						return;
					}

					// 直接从当前选中行获取值
					this.manuLotnum = this.TZXQcurrentTable.manuLotnum;
					this.flowId = this.TZXQcurrentTable.id;
					this.flowDialogTitle = this.TZXQcurrentTable.name;
					this.flowdiglog = true;
					this.getFlowData();
				} else if (v.title == '日期调整' || v.title.includes('日期调整')) {
					if (!this.TZXQcurrentTable || Object.keys(this.TZXQcurrentTable).length === 0) {
						this.$message.warning('请先选择一条批次数据');
						return;
					}
					this.TZXQdialogVisible = true;
				} else if (v.title == '打印' || v.title.includes('打印')) {
					if (!this.innertableData || this.innertableData.length === 0) {
						this.$message.warning('没有可打印的流向记录数据');
						return;
					}
					this.handlePrint();
				} else if (v.title == '关闭' || v.title.includes('关闭')) {
					this.XQdialogVisible = false;
				}
			},
			dy() {
				const printData = this.planMedicalRecord();
				console.log('打印数据:', printData); // 调试用
				printUtil.init(Winvent);
				printUtil.print(printData);
			},
			// 打印相关
			printMedicalRecord() {
				// 初始化hiprint打印模板
				const template = new hiprint.PrintTemplate({
					template: Winvent, // 使用Wstore模板
					data: this.planMedicalRecord() // 传入打印数据
				});

				// 执行打印
				template.print();
			},

			previewMedicalRecord() {
				// 初始化hiprint打印模板
				const template = new hiprint.PrintTemplate({
					template: Winvent, // 使用Winvent模板
					data: this.planMedicalRecord() // 传入打印数据
				});

				// 执行预览
				template.preview();
			},

			// 开始时间变化值
			startDateHandle(value) {
				if (value) {
					// 使用 JavaScript 的 Date 对象格式化日期
					this.startTime = value
					console.log(this.startTime, 'startTimestartTimestartTime');
				} else {
					this.startTime = '';
				}
			},
			// 结束时间变化值
			endDateHandle(value) {
				if (value) {
					// 使用 JavaScript 的 Date 对象格式化日期
					this.endTime = value
				} else {
					this.endTime = '';
				}
			},

			planMedicalRecord() {
				// 首先检查是否有可打印的数据
				if (!this.innertableData || this.innertableData.length === 0) {
					this.$message.warning('没有可打印的流向记录数据');
					return null; // 返回null表示无法打印
				}

				// 获取当前时间并格式化为yyyy-MM-dd HH:mm:ss
				const formatCurrentTime = () => {
					const now = new Date();
					const year = now.getFullYear();
					const month = String(now.getMonth() + 1).padStart(2, '0');
					const day = String(now.getDate()).padStart(2, '0');
					const hours = String(now.getHours()).padStart(2, '0');
					const minutes = String(now.getMinutes()).padStart(2, '0');
					const seconds = String(now.getSeconds()).padStart(2, '0');
					return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
				};

				// 准备流向记录的打印数据
				const printData = {
					// 头部信息 - 对应Winvent.json中的顶部文本元素
					flowDialogTitle: this.flowDialogTitle || '药品流向记录', // 对话框标题
					nowDateTime: formatCurrentTime(), // 使用格式化后的当前时间

					// 表格数据 - 必须与Winvent模板中的字段完全匹配
					tableData: this.innertableData.map((item, index) => ({
						rowNum: index + 1, // 行号 - 对应"行号"列
						sysNum: item.id || '', // 系统序号 - 对应"系统序号"列
						name: item.name || this.flowDialogTitle || '', // 药品名称 - 对应"药品名称"列
						storage: this.shedIdMap[item.shedId] || '未知', // 入库库房 - 对应"入库库房"列
						source: this.bizMap[item.bizSouc] || '未知', // 业务来源 - 对应"业务来源"列
						changeQty: item.chgCnt || 0, // 变化数量 - 对应"变化数量"列
						beforeQty: item.agoCnt || 0, // 变化前库 - 对应"变化前库"列
						afterQty: item.afrCnt || 0, // 变化后库 - 对应"变化后库"列
						// 以下为Winvent.json中定义但原方法未包含的字段
						unt: item.unt || '', // 计量单位
						purcPric: item.purcPric || 0, // 成本单价
						salePric: item.salePric || 0, // 零售单价
						drugSpec: item.drugSpec || '', // 药品规格
						prodentpName: item.prodentpName || '', // 生产厂家
						manuLotnum: item.manuLotnum || '' // 生产批号
					})),

					// 底部信息 - 对应Winvent.json中的底部文本元素
					businessDate: `${this.startDate} 至 ${this.endDate}`, // 业务日期范围
					operator: this.userInfo.userName || '未知', // 操作人
					reviewer: '系统审核' // 过单人
				};

				return printData;
			},
			// 确定更新有效期
			async TZXQSubmit() {
				// 检查日期是否发生变化
				if (!this.TZXQcurrentTable.manuDate && !this.TZXQcurrentTable.expyDate) {
					this.$message.warning('请至少修改一个日期字段');
					return;
				}

				try {
					this.loading = true;

					// 准备请求参数
					const params = {
						id: this.TZXQcurrentTable.id,
						// manuDate: this.TZXQcurrentTable.manuDate,
						expyDate: this.TZXQcurrentTable.expyDate
					};

					const res = await updateZYDate(params);

					if (res.code === 200) {
						this.$message.success('有效期更新成功');
						this.TZXQdialogVisible = false;

						// 可选：刷新批次数据
						this.getBatchNumberData();
					} else {
						this.$message.error(res.message || '有效期更新失败');
					}
				} catch (error) {
					console.error('更新有效期出错:', error);
					this.$message.error('更新有效期出错');
				} finally {
					this.loading = false;
				}
			},
			// input 
			handleClose(done) {
				this.$confirm('确认关闭？')
					.then(_ => {
						this.$refs['addForm'].resetFields();
						done();
					})
					.catch(_ => {

					});
			},
			XQhandleClose(done) {
				this.$confirm('确认关闭？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// 重置相关数据
					this.XQtableData = [];
					this.TZXQcurrentTable = {};
					this.XQdialogVisible = false;
					if (done) done();
				}).catch(() => {
					this.$message.info('已取消关闭');
				});
			},
			TZXQhandleClose(done) {
				this.$confirm('确认关闭？')
					.then(_ => {
						// this.$refs['addForm'].resetFields();
						done();
					})
					.catch(_ => {

					});
			},
			flowhandleClose(done) {
				this.$confirm('确认关闭？')
					.then(_ => {
						done();
					})
					.catch(_ => {});
			},
			// db events
			// 步骤
			handClick(i) {
				// i event
				switch (i) {
					case 0:
						// 处理索引0的逻辑 => 刷新
						this.loading = true;
						setTimeout(() => {
							this.reload();
							this.$message({
								type: 'success',
								message: '已刷新'
							})
							this.loading = false;
						}, 1500)
						break;
					case 1:
						// 处理索引1的逻辑
						this.$confirm('敬请期待')
							.then(_ => {})
							.catch(_ => {});
						break;
				}
			},
			// 打印按钮点击事件
			async handlePrint() {
				if (!this.innertableData || this.innertableData.length === 0) {
					this.$message.warning('没有可打印的流向记录数据');
					return;
				}

				this.$confirm('请选择打印方式', '打印设置', {
					confirmButtonText: 'Lodop打印',
					cancelButtonText: '浏览器打印',
					type: 'warning'
				}).then(() => {
					// 用户选择Lodop打印
					const printData = this.planMedicalRecord();
					console.log('打印数据:', printData);
					printUtil.init(Winvent);
					printUtil.print(printData);
				}).catch(() => {
					// 用户选择浏览器打印
					const printData = this.planMedicalRecord();
					printUtil.init(Winvent);
					printUtil.preview(printData);
				});
			},
			// 使用Lodop打印并设计
			printWithLodop() {
				// if (!this.currentTable || this.currentTable.length === 0) {
				//     this.$message.warning('请先选择一条数据');
				//     return;
				//   }

				// 准备表格数据
				const tableData = this.tableData.map(item => {
					return {
						...item,
						// 添加任何需要转换的字段
					};
				});

				// 准备当前选中行数据
				const currentTable = this.currentTable;

				this.$router.push({
					path: '/PrintTemplateDesigner',
					query: {
						tableData: JSON.stringify(tableData),
						currentTable: JSON.stringify(tableData),
						templateName: '【中药库】药品库存清单'
					}
				});
			},
			// 生产日期变化处理
			handleManuDateChange(value) {
				if (!value) return;

				// 如果有效期已设置且小于生产日期，提示用户
				if (this.TZXQcurrentTable.expyDate &&
					new Date(value) > new Date(this.TZXQcurrentTable.expyDate)) {
					this.$message.warning('生产日期不能晚于有效日期');
					this.TZXQcurrentTable.manuDate = ''; // 清空选择
				}
			},

			// 有效日期变化处理
			handleExpyDateChange(value) {
				if (!value) return;

				const currentDate = new Date();
				const manuDate = this.TZXQcurrentTable.manuDate ? new Date(this.TZXQcurrentTable.manuDate) : null;

				// 检查是否小于当前日期
				if (new Date(value) < currentDate) {
					this.$message.warning('有效日期不能早于当前日期');
					this.TZXQcurrentTable.expyDate = ''; // 清空选择
					return;
				}

				// 检查是否小于生产日期
				if (manuDate && new Date(value) < manuDate) {
					this.$message.warning('有效日期不能早于生产日期');
					this.TZXQcurrentTable.expyDate = ''; // 清空选择
				}
			},
			handleCommand(command) {
				// console.log(command);
				// 根据 command 值执行相应的逻辑
				switch (command) {
					case 'a':
						// 处理a的逻辑
						console.log('执行A逻辑');
						this.DropDownedName = '可用'
						break;
					case 'b':
						// 处理b的逻辑
						console.log('执行B逻辑');
						this.DropDownedName = '禁用'
						break;
					case 'c':
						// 处理b的逻辑
						this.DropDownedName = '全部'
						break;
						// ... 其他 case
				}
			},
			// 实时宽度
			updateWindowWidth() {
				this.windowWidth = window.innerWidth - 228;
			},
			// ==================== 库存预警相关方法 ====================

			// 加载库存预警数据
			async loadWarningData() {
				this.warningLoading = true;
				try {
					let params = {
						drugName: this.warningFilterForm.name,
						pageNum: this.warningPageNum,
						pageSize: this.warningPageSize,
					};

					let res = await alertListZYK(params);
					this.$message.success(res, '获取预警数据cg');
					if (res.code === 200) {
						this.warningTableData = res.data;
						this.warningTotalSize = res.data.totalSize || res.data.length;
					} else {
						this.$message.error(res.message || '获取预警数据失败');
						this.warningTableData = [];
					}
				} catch (error) {
					this.$message.error('请求预警数据出错: ' + error.message);
					this.warningTableData = [];
				} finally {
					this.warningLoading = false;
				}
			},

			// 加载预警编辑数据
			async loadWarningEditData() {
				this.warningLoading = true;
				try {
					let params = {
						name: this.warningFilterForm.name,
						pageNum: this.warningEditPageNum,
						pageSize: this.warningEditPageSize,
					};

					let res = await alertPagesZYK(params);

					if (res.code === 200) {
						// 为每一行数据添加索引，用于单元格编辑
						this.warningEditTableData = (res.data || []).map((item, index) => {
							return {
								...item,
								index: index // 添加索引用于单元格定位
							};
						});
						this.warningEditTotalSize = res.data.totalSize || res.data.length;
					} else {
						this.$message.error(res.message || '获取预警编辑数据失败');
						this.warningEditTableData = [];
					}
				} catch (error) {
					this.$message.error('请求预警编辑数据出错: ' + error.message);
					this.warningEditTableData = [];
				} finally {
					this.warningLoading = false;
				}
			},

			// 预警表格单元格类名
			warningTableCellClassName({
				row,
				column,
				rowIndex,
				columnIndex
			}) {
				row.index = rowIndex;
				column.index = columnIndex;
			},

			// 预警编辑表格双击事件
			warningEditDbClick(row, column) {
				// 只允许编辑最低库存和最高库存列（列索引7和8）
				if (column.property === 'cntLow' || column.property === 'cntHigh') {
					this.warningCurrentCell = `warning_${row.index}_${column.index}`;

					// 双击后自动获得焦点
					this.$nextTick(() => {
						const inputRef = this.$refs[this.warningCurrentCell];
						if (inputRef && inputRef.focus) {
							inputRef.focus();
						}
					});
				} else {
					this.$message.warning('只有最低库存和最高库存允许编辑');
				}
			},

			// 最低库存输入框失去焦点
			warningEditHideInput(row) {
				this.validateWarningInput(row, 'cntLow', '最低库存');
			},

			// 最高库存输入框失去焦点
			warningEditHighHideInput(row) {
				this.validateWarningInput(row, 'cntHigh', '最高库存');
			},

			// 验证预警输入数据
			validateWarningInput(row, field, fieldName) {
				const numberRegex = /^\d+$/;

				if (!numberRegex.test(row[field])) {
					this.$message.error(`${fieldName}格式不正确! 请输入正整数`);
					return false;
				} else if (String(row[field]).length > 8) {
					this.$message.error(`${fieldName}最大长度单位为8！`);
					return false;
				}

				// 验证最低库存不能大于最高库存
				if (field === 'cntLow' && row.cntHigh && Number(row.cntLow) > Number(row.cntHigh)) {
					this.$message.error('最低库存数量不能大于最高库存数量！');
					return false;
				}

				// 验证最高库存不能小于最低库存
				if (field === 'cntHigh' && row.cntLow && Number(row.cntHigh) < Number(row.cntLow)) {
					this.$message.error('最高库存数量不能小于最低库存数量！');
					return false;
				}

				this.warningCurrentCell = null;
				this.warningSubmitData = {
					...row
				};
				this.$message.success(`${fieldName}设置成功！`);
				return true;
			},

			// 预警编辑提交
			async warningEditSubmit() {
				if (!this.warningSubmitData || Object.keys(this.warningSubmitData).length === 0) {
					this.$message.warning('请先设置预警数量');
					return;
				}

				this.warningLoading = true;
				try {
					let res = await alertZYK(this.warningSubmitData);
					if (res.code === 200) {
						this.$message.success('预警设置成功！');
						this.warningEditVisible = false;
						this.loadWarningData(); // 刷新预警列表
					} else {
						this.$message.error(res.message || '预警设置失败');
					}
				} catch (error) {
					this.$message.error('预警设置出错: ' + error.message);
				} finally {
					this.warningLoading = false;
				}
			},

			// 设置预警数量按钮点击
			handleSetWarning() {
				this.warningEditVisible = true;
				this.warningEditPageNum = 1;
				this.loadWarningEditData();
			},

			// 预警刷新按钮
			handleWarningRefresh() {
				this.warningPageNum = 1;
				this.loadWarningData();
			},

			// 预警筛选查询
			handleWarningFilter() {
				this.warningPageNum = 1;
				this.loadWarningData();
			},

			// 预警下拉菜单选择
			handleWarningCommand(command) {
				switch (command) {
					case 'a':
						this.warningDropDownedName = '卫材';
						break;
					case 'b':
						this.warningDropDownedName = '疫苗';
						break;
					case 'c':
						this.warningDropDownedName = '中成药';
						break;
					case 'd':
						this.warningDropDownedName = '中药';
						break;
					case 'e':
						this.warningDropDownedName = '全部';
						break;
				}
				this.handleWarningFilter();
			},

			// 预警表格行选择
			handleWarningCurrentChange(val) {
				this.warningCurrentTable = val;
			},

			// 预警分页大小改变
			handleWarningSizeChange(val) {
				this.warningPageSize = val;
				this.warningPageNum = 1;
				this.loadWarningData();
			},


			// 预警编辑分页大小改变
			handleWarningEditSizeChange(val) {
				this.warningEditPageSize = val;
				this.warningEditPageNum = 1;
				this.loadWarningEditData();
			},

			// 预警编辑当前页改变
			handleWarningEditCurrentChange(val) {
				this.warningEditPageNum = val;
				this.loadWarningEditData();
			},

			// 预警编辑对话框关闭
			warningEditHandleClose(done) {
				this.$confirm('确认关闭？未保存的修改将丢失。', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.warningEditVisible = false;
					if (done) done();
				}).catch(() => {
					this.$message.info('已取消关闭');
				});
			},

			// 预警列宽计算
			warningColumnWidth(col, list) {
				let prop = col.prop,
					lab = col.name || col.lab;
				let width = 20;
				let maxlenStr = "";

				for (let info of list) {
					if (maxlenStr < (info[prop] + "").length) maxlenStr = info[prop];
				}

				width = Math.max(width, this.len(lab), this.len(maxlenStr));
				return width + 12;
			},

			// 字符串长度计算（复用原有方法）
			len(str) {
				let length = 8;
				for (const char of str + "") {
					if ("a" <= char && char <= "z") length += 8;
					else if ("A" <= char && char <= "Z") length += 8;
					else if (Number.isFinite(Number(char))) length += 8;
					else if (char >= "\u4e00" && char <= "\u9fa5") length += 18;
					else length += 12;
				}
				return length;
			},
			// ==================== 图表相关方法 ====================

			// 初始化图表
			initChart() {
				const chartDom = document.getElementById('inventoryChart');
				if (!chartDom) return;

				if (this.chart) {
					this.chart.dispose();
				}

				this.chart = echarts.init(chartDom);

				// 添加窗口大小变化监听
				window.addEventListener('resize', this.handleChartResize);
			},

			// 处理图表大小变化
			handleChartResize() {
				if (this.chart) {
					this.chart.resize();
				}
			},

			// 更新图表数据
			updateChart() {
				if (!this.chart || !this.tableData || this.tableData.length === 0) {
					return;
				}

				const chartData = this.prepareChartData();
				const option = this.getChartOption(chartData);

				this.chart.setOption(option, true);

				// 更新统计信息
				this.updateChartStats();
			},

			// 准备图表数据
			prepareChartData() {
				const data = this.tableData;

				// 根据分组方式处理数据
				let groupedData = {};
				data.forEach(item => {
					const groupKey = this.getGroupKey(item);
					if (!groupedData[groupKey]) {
						groupedData[groupKey] = {
							name: groupKey,
							value: 0,
							count: 0,
							items: []
						};
					}

					const value = Number(item[this.chartDataField]) || 0;
					groupedData[groupKey].value += value;
					groupedData[groupKey].count++;
					groupedData[groupKey].items.push(item);
				});

				// 转换为数组并排序
				return Object.values(groupedData)
					.sort((a, b) => b.value - a.value)
					.slice(0, 20); // 只显示前20个
			},

			// 获取分组键
			getGroupKey(item) {
				const groupField = this.chartGroupBy;
				let key = item[groupField];

				// 处理映射关系
				if (groupField === 'drugType' && this.drugTypeMap[key]) {
					return this.drugTypeMap[key];
				} else if (groupField === 'dosForm' && this.dosformMap[key]) {
					return this.dosformMap[key];
				} else if (groupField === 'shedId' && this.shedIdMap[key]) {
					return this.shedIdMap[key];
				}

				return key || '未知';
			},

			// 获取图表配置
			getChartOption(chartData) {
				const isValueChart = ['line', 'bar', 'candlestick'].includes(this.chartType);
				const isPieChart = this.chartType === 'pie';
				const isTreeChart = this.chartType === 'treemap';

				const baseOption = {
					title: {
						text: this.getChartTitle(),
						left: 'center',
						textStyle: {
							fontSize: 16,
							fontWeight: 'bold'
						}
					},
					tooltip: {
						trigger: isValueChart ? 'axis' : 'item',
						formatter: (params) => this.getTooltipFormatter(params)
					},
					toolbox: {
						feature: {
							saveAsImage: {
								title: '保存为图片'
							},
							dataView: {
								title: '数据视图'
							},
							restore: {
								title: '还原'
							}
						}
					},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '10%',
						containLabel: true
					}
				};

				// 根据不同图表类型返回不同配置
				switch (this.chartType) {
					case 'line':
						return {
							...baseOption,
							xAxis: {
									type: 'category',
									data: chartData.map(d => d.name),
									axisLabel: {
										rotate: 45
									}
								},
								yAxis: {
									type: 'value',
									name: this.getYAxisName()
								},
								series: [{
									type: 'line',
									data: chartData.map(d => d.value),
									smooth: true,
									itemStyle: {
										color: '#5470c6'
									},
									areaStyle: {
										color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
												offset: 0,
												color: 'rgba(84, 112, 198, 0.5)'
											},
											{
												offset: 1,
												color: 'rgba(84, 112, 198, 0.1)'
											}
										])
									}
								}]
						};

					case 'bar':
						return {
							...baseOption,
							xAxis: {
									type: 'category',
									data: chartData.map(d => d.name),
									axisLabel: {
										rotate: 45
									}
								},
								yAxis: {
									type: 'value',
									name: this.getYAxisName()
								},
								series: [{
									type: 'bar',
									data: chartData.map(d => d.value),
									itemStyle: {
										color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
												offset: 0,
												color: '#83bff6'
											},
											{
												offset: 0.5,
												color: '#188df0'
											},
											{
												offset: 1,
												color: '#188df0'
											}
										])
									}
								}]
						};

					case 'pie':
						return {
							...baseOption,
							series: [{
								type: 'pie',
								data: chartData.map(d => ({
									name: d.name,
									value: d.value
								})),
								radius: ['40%', '70%'],
								itemStyle: {
									borderRadius: 10,
									borderColor: '#fff',
									borderWidth: 2
								},
								label: {
									formatter: '{b}: {c} ({d}%)'
								}
							}]
						};

					case 'treemap':
						return {
							...baseOption,
							series: [{
								type: 'treemap',
								data: chartData.map(d => ({
									name: d.name,
									value: d.value
								})),
								upperLabel: {
									show: true,
									height: 30
								},
								itemStyle: {
									borderColor: '#fff'
								}
							}]
						};

					case 'candlestick':
						// 为K线图生成模拟数据
						const candleData = this.generateCandleData(chartData);
						return {
							...baseOption,
							xAxis: {
									type: 'category',
									data: candleData.categories,
									boundaryGap: false,
									axisLine: {
										onZero: false
									},
									splitLine: {
										show: false
									},
									min: 'dataMin',
									max: 'dataMax'
								},
								yAxis: {
									type: 'value',
									scale: true,
									splitArea: {
										show: true
									}
								},
								series: [{
									type: 'candlestick',
									data: candleData.values,
									itemStyle: {
										color: '#ec0000',
										color0: '#00da3c',
										borderColor: '#8A0000',
										borderColor0: '#008F28'
									}
								}]
						};

					default:
						return baseOption;
				}
			},

			// 生成K线图数据
			generateCandleData(chartData) {
				const categories = chartData.map(d => d.name);
				const values = chartData.map(d => {
					const baseValue = d.value;
					const open = baseValue;
					const close = baseValue * (0.9 + Math.random() * 0.2);
					const low = Math.min(open, close) * (0.8 + Math.random() * 0.1);
					const high = Math.max(open, close) * (1.1 + Math.random() * 0.1);

					return [open, close, low, high];
				});

				return {
					categories,
					values
				};
			},

			// 获取图表标题
			getChartTitle() {
				const fieldMap = {
					'purcCnt': '库存数量',
					'purcAmt': '成本金额',
					'saleAmt': '零售金额',
					'drugType': '药品类型'
				};

				const groupMap = {
					'drugType': '药品类型',
					'shedId': '库房',
					'dosForm': '剂型'
				};

				return `${fieldMap[this.chartDataField]}分布 - 按${groupMap[this.chartGroupBy]}分组`;
			},

			// 获取Y轴名称
			getYAxisName() {
				const fieldMap = {
					'purcCnt': '数量',
					'purcAmt': '金额(元)',
					'saleAmt': '金额(元)',
					'drugType': '计数'
				};
				return fieldMap[this.chartDataField] || '';
			},

			// 格式化提示框
			getTooltipFormatter(params) {
				if (this.chartType === 'pie' || this.chartType === 'treemap') {
					const data = params.data;
					return `${data.name}: ${data.value}<br/>占比: ${params.percent}%`;
				} else {
					return `${params[0].name}: ${params[0].value}`;
				}
			},

			// 更新图表统计信息
			updateChartStats() {
				const data = this.tableData;
				this.chartStats = {
					totalDrugs: data.length,
					totalStock: data.reduce((sum, item) => sum + (Number(item.purcCnt) || 0), 0),
					totalCost: data.reduce((sum, item) => sum + (Number(item.purcAmt) || 0), 0),
					avgStock: data.length > 0 ?
						Math.round(data.reduce((sum, item) => sum + (Number(item.purcCnt) || 0), 0) / data.length) : 0
				};
			},

			// 刷新图表
			refreshChart() {
				this.updateChart();
			},

			// 导出图表
			downloadChart() {
				if (this.chart) {
					const url = this.chart.getDataURL({
						type: 'png',
						pixelRatio: 2,
						backgroundColor: '#fff'
					});

					const link = document.createElement('a');
					link.href = url;
					link.download = `库存分析图表_${new Date().toISOString().slice(0, 10)}.png`;
					document.body.appendChild(link);
					link.click();
					document.body.removeChild(link);
				}
			},
		}
	};
</script>

<style lang="less" scoped>
	.xyk-container {
		height: 100%;
		padding: 20px;
		display: flex;
		flex-direction: column;
	}

	/* 表格容器包装器 */
	.table-container-wrapper {
		display: flex;
		width: 100%;
		transition: all 0.3s ease;
		position: relative;
		overflow: hidden;

		&.batch-expanded {
			.main-table-section {
				width: 50%;
				transition: width 0.3s ease;
			}

			.batch-table-section {
				width: 50%;
				opacity: 1;
				transform: translateX(0);
			}
		}
	}
/* 价格调整按钮样式 */
.price-adjust-btn {
    margin-left: 5px;
    margin-right: 5px;
}

/* 价格调整对话框样式 */
.price-adjust-dialog .el-dialog__body {
    padding: 20px;
}

.price-adjust-form .el-form-item {
    margin-bottom: 20px;
}

.price-adjust-form .el-input-number {
    width: 100%;
}
	/* 主表格区域 */
	.main-table-section {
		width: 100%;
		transition: width 0.3s ease;
	}

	/deep/ .el-dialog {
		max-height: 90vh;
		display: flex;
		flex-direction: column;

		.el-dialog__body {
			flex: 1;
			overflow-y: auto;
			padding: 20px;
		}

		&__header {
			background: linear-gradient(135deg, #1a6be0 0%, #409EFF 100%);
			padding: 12px 20px;
			border-bottom: 1px solid #e6e6e6;
			display: flex;

			.el-dialog__title {
				color: #fff;
				font-size: 16px;
				font-weight: bold;
			}
		}

		.el-dialog__headerbtn .el-dialog__close {
			color: #fff;
		}

		.el-dialog__headerbtn .el-dialog__close:hover {
			color: #f80000;
		}
	}

	/* 批次表格区域 */
	.batch-table-section {
		width: 0;
		opacity: 0;
		transform: translateX(100%);
		transition: all 0.3s ease;
		background: #fff;
		border-left: 1px solid #ebeef5;
		display: flex;
		flex-direction: column;

		&.expanded {
			width: 40%;
			opacity: 1;
			transform: translateX(0);
		}

		.batch-table-header {
			padding: 16px;
			border-bottom: 1px solid #ebeef5;
			background: #fafbfc;

			.batch-table-title {
				display: flex;
				justify-content: space-between;
				align-items: center;

				span {
					font-size: 16px;
					font-weight: 600;
					color: #303133;
				}

				.close-btn {
					color: #909399;
					font-size: 16px;

					&:hover {
						color: #f56c6c;
					}
				}
			}
		}

		.batch-table-container {
			flex: 1;
			overflow: hidden;
		}

		.batch-pagination-section {
			padding: 16px;
			border-top: 1px solid #ebeef5;
			background: #fafbfc;
		}
	}

	/* 表格区域通用样式 */
	.table-section {
		background: #fff;
		border-radius: 8px;
		flex: 1;
		display: flex;
		flex-direction: column;
		overflow: hidden;

		.table-header {
			padding: 16px;
			border-bottom: 1px solid #ebeef5;
			display: flex;
			justify-content: space-between;
			align-items: center;
			flex-shrink: 0;

			.table-stats {
				display: flex;
				gap: 40px;

				.table-stat-item {
					display: flex;
					align-items: center;
					gap: 8px;

					.stat-label {
						font-size: 14px;
						color: #606266;
						font-weight: 500;
					}

					.stat-value {
						font-size: 16px;
						font-weight: bold;
						color: #409EFF;
					}
				}
			}
		}

		.table-container {
			flex: 1;
			overflow: hidden;
		}

		.pagination-section {
			padding: 16px;
			border-top: 1px solid #ebeef5;
			background: #fafbfc;
		}
	}

	/* 响应式设计 */
	@media screen and (max-width: 1200px) {
		.table-container-wrapper.batch-expanded {
			.main-table-section {
				width: 50%;
			}

			.batch-table-section {
				width: 50%;
			}
		}
	}

	@media screen and (max-width: 768px) {
		.table-container-wrapper.batch-expanded {
			flex-direction: column;

			.main-table-section,
			.batch-table-section {
				width: 100%;
			}

			.batch-table-section {
				border-left: none;
				border-top: 1px solid #ebeef5;
			}
		}
	}

	/* 动画效果 */
	@keyframes slideInRight {
		from {
			transform: translateX(100%);
			opacity: 0;
		}

		to {
			transform: translateX(0);
			opacity: 1;
		}
	}

	.batch-table-section.expanded {
		animation: slideInRight 0.3s ease;
	}

	/* 滚动条优化 */
	.table-container ::-webkit-scrollbar {
		width: 6px;
		height: 6px;
	}

	.table-container ::-webkit-scrollbar-track {
		background: #f1f1f1;
		border-radius: 3px;
	}

	.table-container ::-webkit-scrollbar-thumb {
		background: #c1c1c1;
		border-radius: 3px;

		&:hover {
			background: #a8a8a8;
		}
	}
</style>